module.exports = __webpack_public_path__ + "assets/img/live-broadcast-icon1.16f47d1b.png";